export default "__VITE_ASSET__7271545a__"